import fancybox from 'vendor/fancybox/jquery.fancybox';
export default class SearchSuggest {
    constructor() {
        this.$result = $('.search-suggest-result');
        this.$input = $('.header-middle__search-input');
        this.$changer = $('.search-changer');
        this.$searchPopup = $('.search-popup');
        this.$form = $('.header-middle__search-form');

        this.searchMode = $('.search-changer__item.search-changer__item--selected').attr("data-type");
        let self = this;

        this.$result.mCustomScrollbar({
            theme: 'dark-3',
            scrollInertia: 200,
        });

        this.$input.on('input', this.onInput.bind(this));
        this.$input.on('click', this.showResults.bind(this));
        this.$changer.on('click', this.showSearchModePopup.bind(this));
        this.$searchPopup.on('click', this.setSearchMode.bind(this));
    }

    setSearchMode(e) {
        if ($(e.target).hasClass("search-popup__item") && !$(e.target).hasClass("search-popup__item--selected")) {
            this.searchMode = $(e.target).attr("data-type");
            this.$searchPopup.addClass('hidden');
            this.showSelectedMode();
            this.changeSearchAction();
        }
    }

    changeSearchAction() {
        let action = "search";
        if (this.searchMode == "model") {
            action = "search-model";
        }

        this.$form.attr('action', "/" + action + "/")
    }

    showSearchModePopup() {
        this.$searchPopup.toggleClass('hidden');
        this.bindOnBlurSearchPopup();
    }

    showSelectedMode() {
        this.$changer.find(".search-changer__item").removeClass("search-changer__item--selected");
        this.$changer.find(`[data-type=${this.searchMode}].search-changer__item`).addClass("search-changer__item--selected");
        this.$searchPopup.find(".search-popup__item").removeClass("search-popup__item--selected")
        this.$searchPopup.find(`[data-type=${this.searchMode}].search-popup__item`).addClass("search-popup__item--selected");
        this.bindOnBlurSearchPopup();
        this.search();
    }

    bindOnBlurSearchPopup() {
        $('body').on('click.search-popup', this.hideOnBlurSearchPopup.bind(this));
    }

    unbindOnBlurSearchPopup() {
        $('body').off('click.search-popup');
    }

    hideOnBlurSearchPopup(e) {
        if (!$(e.target).closest(".search-changer").length && !$(e.target).closest(".search-popup").length) {
            this.$searchPopup.addClass('hidden');
            this.unbindOnBlurSearchPopup();
        }
    }

    onInput() {
        clearTimeout(this.inputTimeout);
        this.inputTimeout = setTimeout(this.search.bind(this), 700);
    }

    search() {
        BX.ajax.runComponentAction('nav:search_sphinx.suggest', 'search', {
            mode: 'class',
            signedParameters: app.searchSphinxSuggest.signedParameters,
            data: {
                'query': this.$input.val(),
                'mode': this.searchMode
            }
        }).then((response) => {
            const data = response.data;

            if (!data.status || data.status != 'ok') {
                console.error(data.error);
                return;
            }
            this.$result.find('.mCSB_container').html(data.html);
            this.showResults();
            this.initFancybox();
        });
    }

    showResults() {
        if (this.$result.find('.mCSB_container').children().length == 0) {
            this.$result.addClass('hidden');
            return;
        }

        this.$result.removeClass('hidden');
        this.$result.mCustomScrollbar('update');
        this.bindOnBlur();
        $(document).trigger($.Event('custom:ProductListItemCollection.reinit'));
    }

    initFancybox() {
        const images = [];

        $('.product-list-item__image').on('click', (e) => {
            e.preventDefault();
            const src = $(e.currentTarget).attr('data-src');
            if (src) {
                $.fancybox.open({
                    src
                }, {
                    loop: true,
                    arrows: true,
                    buttons: ['close'],
                }, $(e.currentTarget).closest('.product-list-item__image-link').attr('data-index'));
            }
        })
    }

    bindOnBlur() {
        $('body').on('click.searchSuggest', this.hideOnBlur.bind(this));
    }

    unbindOnBlur() {
        $('body').off('click.searchSuggest');
    }

    hideOnBlur(e) {
        if (!$(e.target).hasClass("fancybox-slide")
            && !$(e.target).hasClass("header-middle__search-input")
            && $(e.target).closest('.search-suggest-result').length == 0) {
            this.$result.addClass('hidden');
            this.unbindOnBlur();
        }
    }
}